var map = {
	"./de.json": 5894,
	"./de_countries.json": 2615,
	"./de_qm.json": 7745,
	"./en.json": 4174,
	"./en_countries.json": 3071,
	"./en_qm.json": 1017,
	"./fr.json": 4605,
	"./fr_countries.json": 8884,
	"./fr_qm.json": 8860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2814;